import { render, staticRenderFns } from "./LxButtonMenu.vue?vue&type=template&id=cac307da"
import script from "./LxButtonMenu.vue?vue&type=script&lang=js"
export * from "./LxButtonMenu.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports